import { Paper } from '@mui/material'
import { styled } from '@mui/material/styles'
import { xxllncColor } from '../../layout/themes'

export const PREFIX = 'xxllncResearchPanel'

export const classes = {
  header: `${PREFIX}-header`,
  buttonGroup: `${PREFIX}-buttonGroup`,
  pillButton: `${PREFIX}-pillButton`,
  caseItem: `${PREFIX}-caseItem`,
  caseItemLinked: `${PREFIX}-caseItemLinked`,
  searchRow: `${PREFIX}-searchRow`,
}

export const statusColor: Record<string, { bg: string; text: string }> = {
  open: { bg: xxllncColor.opBlue20, text: xxllncColor.blue100 },
  new: { bg: xxllncColor.opGreen20, text: xxllncColor.green100 },
  resolved: { bg: xxllncColor.dark20, text: xxllncColor.mineShaft },
  closed: { bg: xxllncColor.dark20, text: xxllncColor.mineShaft },
  completed: { bg: xxllncColor.dark20, text: xxllncColor.mineShaft },
}

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: '16px',
  border: `1px solid ${xxllncColor.alto}`,
  boxShadow: 'none',
  minHeight: '50vh',

  [`& .${classes.header}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3),
  },

  [`& .${classes.buttonGroup}`]: {
    display: 'flex',
    gap: theme.spacing(0.75),
  },

  [`& .${classes.pillButton}`]: {
    'borderRadius': '20px',
    'textTransform': 'none',
    'fontSize': '0.8rem',
    'padding': theme.spacing(0.5, 1.5),
    'borderColor': xxllncColor.alto,
    'color': xxllncColor.mineShaft,
    '&:hover': {
      borderColor: xxllncColor.blue100,
      color: xxllncColor.blue100,
      backgroundColor: xxllncColor.opBlue10,
    },
  },

  [`& .${classes.searchRow}`]: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1.5),
  },

  [`& .${classes.caseItem}`]: {
    'display': 'flex',
    'alignItems': 'flex-start',
    'gap': theme.spacing(1.5),
    'padding': theme.spacing(1.5),
    'borderRadius': '10px',
    'cursor': 'pointer',
    'transition': 'background-color 0.15s ease',
    'borderBottom': `1px solid ${xxllncColor.light40}`,
    '&:hover': {
      backgroundColor: xxllncColor.light40,
    },
    '&:last-of-type': {
      borderBottom: 'none',
    },
  },

  [`& .${classes.caseItemLinked}`]: {
    backgroundColor: xxllncColor.opGreen10,
    borderColor: xxllncColor.opGreen20,
  },
}))